import { render, staticRenderFns } from "./Prompt.vue?vue&type=template&id=01aeae62&scoped=true"
import script from "./Prompt.vue?vue&type=script&lang=ts"
export * from "./Prompt.vue?vue&type=script&lang=ts"
import style0 from "./Prompt.vue?vue&type=style&index=0&id=01aeae62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aeae62",
  null
  
)

export default component.exports